<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-button
          style="padding: 0; margin: 20px"
          type="text"
          icon="el-icon-back"
          @click="$router.go(-1)"
        >
          返回
        </el-button>

        <el-input
          class="search-el"
          size="mini"
          v-model="query.search"
          placeholder="姓名/手机号"
        ></el-input>
        <el-select
          class="search-el"
          size="mini"
          v-model="query.order"
          placeholder="全部"
        >
          <el-option label="已支付" value="2">已支付</el-option>
          <el-option label="全部订单" value="">全部订单</el-option>
          <el-option label="待支付" value="1">待支付</el-option>
          <el-option label="已取消" value="0">已取消</el-option>
          <el-option label="已支付" value="2">已支付</el-option>
          <el-option label="申请退款" value="3">申请退款</el-option>
          <el-option label="退款处理" value="4">退款处理</el-option>
          <el-option label="退款成功" value="5">退款成功</el-option>
        </el-select>
        <el-button type="primary" size="mini" @click="getList()"> 查询 </el-button>
        <el-button type="primary" size="mini" @click="exportList()">
          导出
        </el-button>
      </el-col>
    </el-row>    

    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0"
      >        
        <el-table-column label="姓名" align="center" min-width="20%" prop="extra.contact_name"></el-table-column>
        <el-table-column label="手机号" align="center" min-width="20%" prop="extra.contact_phone"></el-table-column>
        <el-table-column label="性别" align="center" min-width="20%">
          <template slot-scope="{ row }">
            {{ !row.extra.hasOwnProperty('sex') || row.extra.sex == 0 ? '无' : (row.extra.sex == 1 ? '男' : '女') }}
          </template>
        </el-table-column>
        <el-table-column label="微信号" align="center" min-width="20%" prop="extra.wechat_id"></el-table-column>
        <el-table-column label="地址" align="center" min-width="60%">
            <template slot-scope="{ row }">
            <div>
              {{ row.extra.province }}&nbsp;{{ row.extra.city }}&nbsp;{{ row.extra.district }}&nbsp;{{ row.extra.address }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="created_at"
          label="时间"
          align="center"
          min-width="20%"
        ></el-table-column>

      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
import {
  getUserAddressOrderList,
} from "@/api/course";

const axios = require('axios');

export default {
  data: function () {
    return {
      list: [],
      loading: false,
      total: 0,
      query: {
        target_id: this.$route.query.target_id,
        page: 1,
        limit: 20,
        search: "",
        order: "2",
        export: 0
      },
    };
  },
  created: function () {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      getUserAddressOrderList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },

    exportList() {
      this.query.export = 1;
      this.loading = true;

      axios({
        method: 'post',
        url: '/backend/course/getUserAddressOrderList',
        data: this.query,
        responseType: 'blob'
      }).then((res) => {
        const link = document.createElement('a')
        let blob = new Blob([res.data],{type: 'application/vnd.ms-excel'});
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', '上课人.xls')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        this.loading = false;
        this.query.export = 0;
      }).catch(error => {
        this.$Notice.error({
          title: '错误',
          desc: '网络连接错误'
        })
        console.log(error)
      })
    }
  },
  mounted() {},
};
</script>